import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { DateService } from '../../../../shared/services/date.service';

export interface ESimUsage {
  // Define the structure based on API response
  data_used?: string;
  data_limit?: string;
  text_used?: string;
  text_limit?: string;
  voice_used?: string;
  voice_limit?: string;
  status?: string;
  last_updated?: string;
}

export interface ESimUsageResponse {
  error: boolean;
  data: {
    data: ESimUsage;
  };
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-sim-usage',
  templateUrl: './sim-usage.component.html',
  styleUrl: './sim-usage.component.scss'
})
export class SimUsageComponent implements OnInit {
  usage: ESimUsage | null = null;
  loading = true;
  error: string | null = null;
  iccid: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private authService: AuthService,
    private _dateService: DateService
  ) {}

  ngOnInit(): void {
    this.iccid = this.route.snapshot.paramMap.get('iccid');
    if (this.iccid) {
      this.loadUsageDetails(this.iccid);
    } else {
      this.error = 'SIM ICCID not found';
      this.loading = false;
    }
  }

  loadUsageDetails(iccid: string): void {
    // The JWT interceptor will automatically add the token header
    this.apiService.getData(`/api/airalo/sims/${iccid}/usage`).subscribe({
      next: (response: ESimUsageResponse) => {
        if (!response.error && response.data && response.data.data) {
          this.usage = response.data.data;
        } else {
          this.error = 'Failed to load SIM usage data';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching SIM usage:', err);
        this.error = 'Error loading SIM usage';
        this.loading = false;
      }
    });
  }

  goBack(): void {
    if (this.iccid) {
      this.router.navigate(['/app/sims', this.iccid]);
    } else {
      this.router.navigate(['/app/sims']);
    }
  }

  formatDate(dateValue: string): string {
    return this._dateService.getFormattedDateWithAMPM(dateValue);
  }
}